// import { gsap } from "../gsap/all.js";
// import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
// gsap.registerPlugin(ScrollTrigger);
// gsap.config({nullTargetWarn:false});
export default {

  init() {

    if ($('.callout').length) {
      $('.submenu-inr').addClass('w-callout');
    }

    $(document).on('click', '.callout .close-button', function () {
      $('.submenu-inr').removeClass('w-callout');
    });


    $('[data-toggle="main-menu"]').on('click', function () {
      $('#main-menu').toggleClass('is-open');
    });

    if ($(".product-slider").length) {
      $('.product-slider').slick({
        dots: true,
        infinite: true,
        autoplaySpeed: 3000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:true,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        ],
      }

      );
    }

    console.log('Found .tslider:', $('.tslider').length);


    if ($(".tslider").length) {
      $('.tslider').slick({
        dots: true,
        arrows:false,
        infinite: false,
        autoplaySpeed: 6000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
      }

      );
    }

    const submenu = document.querySelector('.main-menu');

    submenu.addEventListener('mouseenter', () => {
      document.body.classList.add('lock-scroll');
    });

    submenu.addEventListener('mouseleave', () => {
      document.body.classList.remove('lock-scroll');
    });



   // Navbar
   $( "<span class='clickD'></span>" ).insertAfter(".navbar-nav li.menu-item-has-children > a");
   $('.navbar-nav li .clickD').click(function(e) {
     e.preventDefault();
     var $this = $(this);
     if ($this.next().hasClass('show'))
     {
      $this.next().removeClass('show');
      $this.removeClass('toggled');
    }
    else
    {
      $this.parent().parent().find('.sub-menu').removeClass('show');
      $this.parent().parent().find('.toggled').removeClass('toggled');
      $this.next().toggleClass('show');
      $this.toggleClass('toggled');
    }
  });

   $(window).on('resize', function(){
     if ($(this).width() < 1025) {
       $('html').click(function(){
         $('.navbar-nav li .clickD').removeClass('toggled');
         $('.toggled').removeClass('toggled');
         $('.sub-menu').removeClass('show');
       });
       $(document).click(function(){
         $('.navbar-nav li .clickD').removeClass('toggled');
         $('.toggled').removeClass('toggled');
         $('.sub-menu').removeClass('show');
       });
       $('.navbar-nav').click(function(e){
        e.stopPropagation();
      });
     }
   });
   // Navbar end



   /* ===== For menu animation === */
   $(".navbar-toggler").click(function(){
    $(".navbar-toggler").toggleClass("open");
    $(".navbar-toggler .stick").toggleClass("open");
    $('body,html' ).toggleClass("open-nav");
  });

  // Navbar end


  // Sticky Nav

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
      $(".main-header").addClass("fixed");
    }
    else {
      $(".main-header").removeClass("fixed");
    }
  })


  // back to top
  if($("#scroll").length){
    $(window).scroll(function(){
      if ($(this).scrollTop() > 200) {
        $('#scroll').fadeIn(200);
      } else {
        $('#scroll').fadeOut(200);
      }
    });
    $('#scroll').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 500);
      return false;
    });
  }



  jQuery(function(){
    let $slider     = jQuery('.slider-item');
    let $sliderLen  = $slider.length - 1;
    let sliderArr   = [];

    for (let i = 0; i <= $sliderLen; i++) {
      sliderArr.push(i);
    }

  // Initialize each slider separately
  $slider.each(function(index) {
    jQuery(this).slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: getRandomSpeed(4000, 8000), // Random per slider
      fade: true,
      speed: 1500,
    });
  });

  // Periodically refresh and reshuffle autoplay timings
  setInterval(function () {
    $slider.slick('refresh');
    shuffle(sliderArr);
    changeAutoPlay(sliderArr, $slider);
  }, 180000); // Refresh every 3 mins

  $slider.eq(-1).one('setPosition', function(){
    shuffle(sliderArr);
    changeAutoPlay(sliderArr, $slider);
  });
});

  // Custom autoplay re-init with stagger and random autoplaySpeed
  function changeAutoPlay(arr, $items) {
    arr.forEach(function(i, index){
      setTimeout(function(){
        let speed = getRandomSpeed(4000, 8000); // each slider gets its own speed
        $items.eq(i).slick('slickSetOption', 'autoplaySpeed', speed, true);
        $items.eq(i).slick('slickSetOption', 'autoplay', true, true);
      }, getRandomDelay(1000, 5000)); // staggered re-enabling
    });
  }

  // Random shuffle
  function shuffle(array) {
    let n = array.length, t, i;
    while (n) {
      i = Math.floor(Math.random() * n--);
      t = array[n];
      array[n] = array[i];
      array[i] = t;
    }
    return array;
  }

  // Get random autoplay speed
  function getRandomSpeed(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Get random stagger delay
  function getRandomDelay(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Update the play/pause button UI based on the video’s state
  function updateButtonState(toggleBtn, pauseIcon, playIcon, label, isPlaying) {
    toggleBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    label.textContent = isPlaying ? 'Pause background video' : 'Play background video';

    pauseIcon.classList.toggle('is-shown', isPlaying);
    pauseIcon.classList.toggle('is-hidden', !isPlaying);

    playIcon.classList.toggle('is-shown', !isPlaying);
    playIcon.classList.toggle('is-hidden', isPlaying);
  }

  // Grab your DOM elements once
  const video     = document.getElementById('hero-video');
  const toggleBtn = document.getElementById('video-toggle');
  const pauseIcon = toggleBtn && toggleBtn.querySelector('.fa-pause');
  const playIcon  = toggleBtn && toggleBtn.querySelector('.fa-play');
  const label     = toggleBtn && toggleBtn.querySelector('.visually-hidden');

  // Helper to call updateButtonState safely
  function setBtnState(isPlaying) {
    if (toggleBtn && pauseIcon && playIcon && label) {
      updateButtonState(toggleBtn, pauseIcon, playIcon, label, isPlaying);
    }
  }

  // Only wire up if #hero-video exists and all elements are present
  if (
    video &&       // #hero-video
    toggleBtn &&
    pauseIcon &&
    playIcon &&
    label
  ) {
    // Sync UI when the video actually plays or pauses
    video.addEventListener('play',  () => setBtnState(true));
    video.addEventListener('pause', () => setBtnState(false));

    // Toggle playback on button click
    toggleBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {}); // swallow autoplay errors
      } else {
        video.pause();
      }
    });

    // Try to autoplay on load, then initialize the button state
    video
      .play()
      .catch(() => {
        // if autoplay is blocked, do nothing
      })
      .finally(() => {
        setBtnState(!video.paused);
      });
  }


  const banner = document.querySelector('.callout');
  const closeBannerBtn = document.querySelector('.close-callout');

  if (banner && closeBannerBtn) {
    const items = banner.querySelectorAll('.promo-item');
    const duration = parseInt(banner.dataset.rotateDuration, 10) || 5000;

    if (items.length > 1) {
      let current = 0;

      items.forEach((item, i) => {
        item.style.display = i === 0 ? 'flex' : 'none';
      });

      setInterval(() => {
        items[current].style.display = 'none';
        current = (current + 1) % items.length;
        items[current].style.display = 'flex';
      }, duration);
    }

    closeBannerBtn.addEventListener('click', () => {
      banner.style.display = 'none';
    });
  }


  $('.hamburger-menu-wrap').on('click', function() {
    $('.bar').toggleClass('animate');
    $('.mobile-menu').toggleClass('active');
    return false;
  })

  $('.has-children').on ('click', function() {
   $(this).children('ul').slideToggle('slow', 'swing');
   $('.icon-arrow').toggleClass('open');
 });

  $(document).on('click', '.submenu-arrow', function (e) {
    e.preventDefault();
    if (window.innerWidth >= 1024) return;

    const $parentLi = $(this).closest('li');
    const $submenu = $parentLi.find('> .submenu-inr'); // ✅ FIXED: find submenu that’s a direct child

    console.log('Toggle menu for:', $parentLi);
    console.log('Submenu found:', $submenu.length);

    // Close others (optional)
    $('.main-menu li').not($parentLi).removeClass('active').find('> .submenu-inr').slideUp().removeClass('open');

    $parentLi.toggleClass('active');

    if ($submenu.length) {
      $submenu.stop(true, true).slideToggle(300).toggleClass('open');
    }
  });


  $('.split-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  })

  $('.ss-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    dots: true,
  })

  $('.callout').on('click', '.close-button', function(event) {
    $('.wrap.container').removeClass('has-banner');
    $('.main-header').removeClass('has-banner')
    event.preventDefault();
  });

  // Kill video in modal when modal closes

  $('[data-reveal]').on('closed.zf.reveal', function () {
    let videoIframeSrc = $(this).find('iframe').attr('src');
    $(this).find($('.responsive-embed')).children('iframe').attr('src', '');
    setTimeout(() => {
      $(this).find($('.responsive-embed')).children('iframe').attr('src', videoIframeSrc);
    }, 100)
  });

  // Year/Make/Model Call

  const apiBase = 'https://rufftuffdata.net:8084/';

  function sortBy(field) {
    return (a, b) => a[field].localeCompare(b[field]);
  }

  $(document).ready(function () {
    const $year = $('#yearSelect');
    const $make = $('#makeSelect');
    const $model = $('#modelSelect');

    // Fetch and populate years
    $.get(`${apiBase}/years`, function (data) {
      data.sort((a, b) => b.year - a.year).forEach(item => {
        $year.append(`<option value="${item.year}">${item.year}</option>`);
      });
    });

    // Handle year change
    $year.on('change', function () {
      const year = $(this).val();
      $make.empty().append('<option value="">Make</option>').prop('disabled', !year);
      $model.empty().append('<option value="">Model</option>').prop('disabled', true);

      if (year) {
        $.get(`${apiBase}/year/${year}/makes`, function (data) {
          data.sort(sortBy('makeDescription')).forEach(item => {
            $make.append(`<option value="${item.makeId}">${item.makeDescription}</option>`);
          });
        });
      }
    });

    // Handle make change
    $make.on('change', function () {
      const makeId = $(this).val();
      const year = $year.val();
      $model.empty().append('<option value="">Model</option>').prop('disabled', !makeId);

      if (makeId) {
        $.get(`${apiBase}/year/${year}/make/${makeId}/models`, function (data) {
          data.sort(sortBy('modelDescription')).forEach(item => {
            $model.append(`<option value="${item.modelId}">${item.modelDescription}</option>`);
          });
        });
      }
    });

    // Construct GET query on submit
    $('#vehicle-form').on('submit', function (e) {
      e.preventDefault();
      const year = $year.val();
      const make = $make.val();
      const model = $model.val();
      const query = $.param({ year, make, model });
      window.location.href = `https://seats-stg.rufftuff.com/?${query}`;
    });
  });

  $('.selector-headline').on('click', 'button', function(event) {
    $('.form-section .form-wrap').toggle();
    $(this).toggleClass('open');
    event.preventDefault();
  });

  const field = document.querySelector('#input_2_72');
  if (!field) return;

  // Get clean slug from current URL
  let slug = window.location.pathname.split('/').filter(Boolean).pop() || '';
  slug = slug.toLowerCase().trim();

  // If there’s a trailing slash or query params, it won’t break
  field.value = slug || 'na';

  console.log(`Gravity Form reseller value set to: ${field.value}`);

},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js